function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import './PivotTable.scss';
import * as d3 from 'd3';
import React, { Component } from 'react';
import dc, { dataTable } from 'dc';
import { AVIChartTile } from '../../Layout/AVIChartTile/AVIChartTile';
import { BaseMixin } from '../Mixins/BaseMixin';
import PropTypes from 'prop-types';
export var PivotTable = /*#__PURE__*/function (_Component) {
  _inheritsLoose(PivotTable, _Component);

  function PivotTable(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "_chart", null);

    _this.chartRef = React.createRef();
    _this.getChart = _this.getChart.bind(_assertThisInitialized(_this));
    _this.createChart = _this.createChart.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = PivotTable.prototype;

  _proto.createChart = function createChart(parent, chartGroup) {
    var _this$props = this.props,
        rowLabelHeader = _this$props.rowLabelHeader,
        format = _this$props.format,
        headerBgColor = _this$props.headerBgColor,
        rowOrder = _this$props.rowOrder,
        columnOrder = _this$props.columnOrder,
        headerTextColor = _this$props.headerTextColor,
        oddRowColor = _this$props.oddRowColor,
        evenRowColor = _this$props.evenRowColor,
        borderColor = _this$props.borderColor,
        rowHoverColor = _this$props.rowHoverColor,
        colTotalLabel = _this$props.colTotalLabel,
        pctRowLabel = _this$props.pctRowLabel,
        rowTotalLabel = _this$props.rowTotalLabel,
        showColTotalRow = _this$props.showColTotalRow,
        showPctRow = _this$props.showPctRow,
        showRowTotalCol = _this$props.showRowTotalCol;

    var _chart = dc.baseMixin({});

    function tag(elem, value, cssClass) {
      if (value === void 0) {
        value = null;
      }

      if (cssClass === void 0) {
        cssClass = null;
      }

      var r = document.createElement(elem);

      if (value) {
        r.innerHTML = value;
      }

      if (cssClass) {
        r.className = cssClass;
      }

      return r;
    }

    function buildTable(tableData, rowLabels, colLabels) {
      var table = tag('table', null, 'pivot-table'); // Add necessary css styles

      var css = "\n        .avi-chart.chart.pivot-table tbody tr:nth-child(even) { background-color: " + evenRowColor + " }\n        .avi-chart.chart.pivot-table tbody tr:nth-child(odd) { background-color: " + oddRowColor + " }\n        .avi-chart.chart.pivot-table tbody tr:hover { background-color: " + rowHoverColor + " }\n      ";
      var style = document.createElement('style');

      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(document.createTextNode(css));
      }

      document.getElementsByTagName('head')[0].appendChild(style); // Build table header

      var headerLabels = [];
      headerLabels = headerLabels.concat([rowLabelHeader]);
      headerLabels = headerLabels.concat(colLabels);

      if (showRowTotalCol) {
        headerLabels = headerLabels.concat([rowTotalLabel]);
      }

      var tableHeader = tag('thead');
      var headerRow = tag('tr', null, 'header');
      headerRow.style.backgroundColor = headerBgColor;
      headerRow.style.color = headerTextColor;
      headerLabels.forEach(function (colLabel) {
        var headerCell = tag('th', colLabel);
        headerRow.appendChild(headerCell);
      });
      tableHeader.appendChild(headerRow);
      table.appendChild(tableHeader); // Build table body

      var tableBody = tag('tbody');
      rowLabels.forEach(function (rowLabel) {
        var trBody = document.createElement('tr');
        var tdRowLabel = tag('td', rowLabel, 'first-col');
        trBody.appendChild(tdRowLabel);
        colLabels.forEach(function (colLabel) {
          var tdData = tag('td', format(tableData[rowLabel][colLabel]), 'data');
          trBody.appendChild(tdData);
        });

        if (showRowTotalCol) {
          var tdRowTotal = tag('td', format(tableData[rowLabel][rowTotalLabel]), 'last-col');
          trBody.appendChild(tdRowTotal);
        }

        tableBody.appendChild(trBody);
      });
      table.appendChild(tableBody); // Build table footer

      var tableFooter = tag('tfoot');

      if (showColTotalRow) {
        var footerRow = tag('tr', null, 'footer');
        var tdPctRowLabel = tag('td', colTotalLabel);
        footerRow.appendChild(tdPctRowLabel);
        colLabels.forEach(function (colLabel) {
          var tdFooterCell = tag('td', format(tableData[colTotalLabel][colLabel]));
          footerRow.appendChild(tdFooterCell);
        });
        var rowColTotalCell = tag('td', format(tableData[colTotalLabel][rowTotalLabel]));
        footerRow.appendChild(rowColTotalCell);
        tableFooter.appendChild(footerRow);
      }

      if (showPctRow) {
        var pctRow = tag('tr', null, 'footer');
        var tdPctRowLabel = tag('td', pctRowLabel);
        pctRow.appendChild(tdPctRowLabel);
        colLabels.forEach(function (colLabel) {
          var tdFooterCell = tag('td', format(tableData[pctRowLabel][colLabel]) + '%');
          pctRow.appendChild(tdFooterCell);
        });
        var rowColTotalCell = tag('td', format(tableData[pctRowLabel][rowTotalLabel]) + '%');
        pctRow.appendChild(rowColTotalCell);
        tableFooter.appendChild(pctRow);
      }

      if (showPctRow || showColTotalRow) {
        table.appendChild(tableFooter);
      }

      return table;
    }

    _chart._doRender = function () {
      // Extract a copy of the group
      var _group = _chart.group().all().slice(0);

      var rowLabels = d3.set(_group.map(function (d) {
        return d.key[0];
      })).values();
      rowLabels.sort(rowOrder);
      var colLabels = d3.set(_group.map(function (d) {
        return d.key[1];
      })).values();
      colLabels.sort(columnOrder);
      var tableData = {};
      tableData[colTotalLabel] = {};
      tableData[colTotalLabel][rowTotalLabel] = 0;
      rowLabels.forEach(function (rl) {
        tableData[rl] = {};
        tableData[rl][rowTotalLabel] = 0;
        colLabels.forEach(function (cl) {
          tableData[rl][cl] = 0;
        });
        colLabels.forEach(function (cl) {
          tableData[colTotalLabel][cl] = 0;
        });
      });

      _group.forEach(function (row) {
        tableData[row.key[0]][row.key[1]] += row.value;
        tableData[colTotalLabel][row.key[1]] += row.value;
        tableData[row.key[0]][rowTotalLabel] += row.value;
        tableData[colTotalLabel][rowTotalLabel] += row.value;
      }); // Optionally calculate a percentage row


      if (showPctRow) {
        var percentages = Object.assign({}, tableData[colTotalLabel]);
        colLabels.forEach(function (colLabel) {
          var v = percentages[colLabel];
          percentages[colLabel] = v / percentages[rowTotalLabel] * 100;
        });
        percentages[rowTotalLabel] = 100;
        tableData[pctRowLabel] = percentages;
      }

      parent.innerHTML = null;
      parent.appendChild(buildTable(tableData, rowLabels, colLabels));
    };

    _chart._doRedraw = function () {
      _chart._doRender();
    };

    return _chart.anchor(parent, chartGroup);
  };

  _proto.componentDidMount = function componentDidMount() {
    this._chart = this.createChart(this.chartRef.current); // Set mixin properties

    BaseMixin(this._chart, this.props); // Render chart

    this._chart.render();
  };

  _proto.getChart = function getChart() {
    return this._chart;
  };

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement(AVIChartTile, {
      title: this.props.chartTitle,
      getChart: this.getChart,
      showTools: false,
      toolsComponent: false
    }, /*#__PURE__*/React.createElement("div", {
      className: "avi-chart chart pivot-table",
      ref: this.chartRef
    }));
  };

  return PivotTable;
}(Component);

_defineProperty(PivotTable, "defaultProps", {
  columnOrder: function columnOrder(a, b) {
    return a.value - b.value;
  },
  rowOrder: function rowOrder(a, b) {
    return a.value - b.value;
  },
  rowTotalLabel: 'Totals column',
  colTotalLabel: 'Totals row',
  rowLabelHeader: '',
  format: d3.format(',.2f'),
  showPctRow: false,
  pctRowLabel: 'Percent',
  headerBgColor: '#000',
  headerTextColor: '#fff',
  oddRowColor: '#fff',
  evenRowColor: '#eee',
  borderColor: '#000',
  rowHoverColor: '#FDD017',
  showRowTotalCol: false,
  showColTotalRow: false
});

PivotTable.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Title to render on the chart */
  chartTitle: PropTypes.string,

  /** A Crossfilter dimension made that returns an array key, e.g. crossfilter.dimension(d=>[d.key, d.key2, ..., d.keyN]).
   * The first element in the array will be the top level of the hierarchy */
  dimension: PropTypes.object.isRequired,

  /** A Crossfilter group made on the same dimension */
  group: PropTypes.object.isRequired,

  /** A sorting function that sorts the row labels, by default sorts alphabetically on d.key[0] */
  rowOrder: PropTypes.func,

  /** A sorting function that sorts the column labels d.key[1] */
  columnOrder: PropTypes.func,

  /** Label for row totals column */
  rowTotalLabel: PropTypes.string,

  /** Label for column totals row */
  colTotalLabel: PropTypes.string,

  /** Value that will appear in the top left cell in the table above the row labels, to the left of the column labels */
  rowLabelHeader: PropTypes.string,

  /** A number formatting function */
  format: PropTypes.func,

  /** Whether to calculate a percentage row */
  showPctRow: PropTypes.bool,

  /** Label to use for percentage row */
  pctRowLabel: PropTypes.string,

  /** Set header row background color for table */
  headerBgColor: PropTypes.string,

  /** Set header row text color */
  headerTextColor: PropTypes.string,

  /** Background color for odd rows in the table body */
  oddRowColor: PropTypes.string,

  /** Backgorund colod for even rows in the table body */
  evenRowColor: PropTypes.string,

  /** Border color */
  borderColor: PropTypes.string,

  /** Hover color for  rows in the table body */
  rowHoverColor: PropTypes.string,

  /** Whether to show column summarizing all data values for each row */
  showRowTotalCol: PropTypes.bool,

  /** Whether to show row summarizing all data values for each column */
  showColTotalRow: PropTypes.bool
} : {};
export default PivotTable;